import * as React from 'react';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';
import { StyleProps } from '../../../../utils/style';
import { CSSProperties } from 'react';
import green from 'material-ui/colors/green';
import red from 'material-ui/colors/red';
import { CircularProgress } from 'material-ui/Progress';
import * as R from 'ramda';

const styleSheet = {
  container: {
    height: '100%',
  } as CSSProperties,
  select: {
    border: 'dashed 1px rgba(255, 255, 255, 0.12)',
    minHeight: 140,
  },
  selectFileButton: {
    color: '#ffff8c',
  } as CSSProperties,
  paper: {
    position: 'relative',
  },
  closeIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 10000,
    color: 'black',
  },
  mediaWrapper: {
    width: '100%',
  },
  successButton: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  errorButton: {
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  progress: {
    color: green[500],
    position: 'absolute',
    top: -2,
    left: -2,
  },
};

interface UploadedFile {
  file: { preview: string };
}

interface OwnProps {
  progress: number;
  uploadedFiles: UploadedFile[];
}

type Props = StyleProps & OwnProps;

class UploadDisplay extends React.PureComponent<Props> {
  private renderPreview() {
    const { uploadedFiles } = this.props;
    const uploadedFile = R.head(uploadedFiles);

    if (!uploadedFile || !uploadedFile.file || !uploadedFile.file.preview) {
      return null;
    }

    return (
      <video style={{ width: '100%', maxWidth: '100%' }} controls={true}>
        <source src={uploadedFile.file.preview} type="video/mp4" />
      </video>
    );
  }

  private renderSelect() {
    const { classes, progress, uploadedFiles } = this.props;
    return (
      <Grid
        className={classes.select}
        alignItems="center"
        justify="center"
        direction="row"
        container={true}
        spacing={0}
      >
        <Grid>
          <Typography align={'center'} type={'body1'}>
            Drop videos
          </Typography>
        </Grid>
        <Grid alignItems="center" justify="center" container={true}>
          {R.length(uploadedFiles) === 0 && !R.is(Number, progress) && (
            <Button className={classes.selectFileButton}>SELECT FILE</Button>
          )}
          {R.is(Number, progress) && (
            <CircularProgress
              size={50}
              mode="determinate"
              value={progress}
              min={0}
              max={100}
            />
          )}
        </Grid>
        <Grid>
          <Typography align={'center'} type={'body1'}>
            Max File Size 10MB
          </Typography>
        </Grid>
      </Grid>
    );
  }

  public render() {
    const { classes, uploadedFiles } = this.props;
    return (
      <Grid className={classes.container}>
        {R.length(uploadedFiles) > 0 && this.renderPreview()}
        {R.length(uploadedFiles) === 0 && this.renderSelect()}
      </Grid>
    );
  }
}

export default withStyles(styleSheet)(UploadDisplay);



// WEBPACK FOOTER //
// ./src/modules/S3MediaDropzone/components/UploadDisplay/index.tsx